module.exports = {
	"tc_0_0_0": {
		"caption": "нет данных"
	},
	"tc_8_97_77": {
		"caption": "УРОВЕНЬ БАКА В НОРМЕ"
	},
	"tc_8_-1_62": {
		"caption": "Связь с ВЕНА-150 Муз.школа Н-Днестровск (RS)"
	},
	"tc_8_90_1": {
		"caption": "ШАТНЦ-Н1/Н2:Шкаф"
	},
	"tc_8_90_2": {
		"caption": "ШАТНЦ-Н1/Н2:Переключать станции: Дистанционный"
	},
	"tc_8_90_3": {
		"caption": "ШАТНЦ-Н1/Н2:Переключать станции: Ручной"
	},
	"tc_8_90_4": {
		"caption": "ШАТНЦ-Н1/Н2:Переключать станции: Выключена"
	},
	"tc_8_90_5": {
		"caption": "ШАТНЦ-Н1/Н2:Переключать насосов: Автоматический"
	},
	"tc_8_90_6": {
		"caption": "ШАТНЦ-Н1/Н2:Переключать насосов: Насос 1"
	},
	"tc_8_90_7": {
		"caption": "ШАТНЦ-Н1/Н2:Переключать насосов: Насос 2"
	},
	"tc_8_90_8": {
		"caption": "ШАТНЦ-Н1/Н2:Режим автомат. выбора насосов"
	},
	"tc_8_90_9": {
		"caption": "ШАТНЦ-Н1/Н2:Рабочий насос 1"
	},
	"tc_8_90_10": {
		"caption": "ШАТНЦ-Н1/Н2:Рабочий насос 2"
	},
	"tc_8_90_11": {
		"caption": "ШАТНЦ-Н1/Н2:ВКЛ. Насос 1"
	},
	"tc_8_90_12": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Обрыв катушки"
	},
	"tc_8_90_13": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Тепловая защита"
	},
	"tc_8_90_14": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Защита по перепаду"
	},
	"tc_8_90_15": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Залипание контактора"
	},
	"tc_8_90_16": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Авария питания"
	},
	"tc_8_90_17": {
		"caption": "ШАТНЦ-Н1/Н2:ВКЛ. Насос 2"
	},
	"tc_8_90_18": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Обрыв катушки"
	},
	"tc_8_90_19": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Тепловая защита"
	},
	"tc_8_90_20": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Защита по перепаду"
	},
	"tc_8_90_21": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Залипание контактора"
	},
	"tc_8_90_22": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Авария питания"
	},
	"tc_8_90_23": {
		"caption": "ШАТНЦ-Н1/Н2: Авария ПУ-1"
	},
	"tc_8_90_24": {
		"caption": "ШАТНЦ-Н1/Н2: Авария ПУ-2"
	},
	"tc_8_90_25": {
		"caption": "ШАТНЦ-Н1/Н2: Защита по сухому ходу"
	},
	"tc_8_90_26": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Авария"
	},
	"tc_8_90_27": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Авария"
	},
	"tc_8_90_28": {
		"caption": "ШАТНЦ-Н1/Н2: Авария"
	},
	"tc_8_90_200": {
		"caption": "Нет связи ШАТНЦ-Н1/Н2"
	},
	"tc_8_91_1": {
		"caption": "ШАТНЦ-Н3/Н4:Шкаф"
	},
	"tc_8_91_2": {
		"caption": "ШАТНЦ-Н3/Н4:Переключать станции: Дистанционный"
	},
	"tc_8_91_3": {
		"caption": "ШАТНЦ-Н3/Н4:Переключать станции: Ручной"
	},
	"tc_8_91_4": {
		"caption": "ШАТНЦ-Н3/Н4:Переключать станции: Выключена"
	},
	"tc_8_91_5": {
		"caption": "ШАТНЦ-Н3/Н4:Переключать насосов: Автоматический"
	},
	"tc_8_91_6": {
		"caption": "ШАТНЦ-Н3/Н4:Переключать насосов: Насос 3"
	},
	"tc_8_91_7": {
		"caption": "ШАТНЦ-Н3/Н4:Переключать насосов: Насос 4"
	},
	"tc_8_91_8": {
		"caption": "ШАТНЦ-Н3/Н4:Режим автомат. выбора насосов"
	},
	"tc_8_91_9": {
		"caption": "ШАТНЦ-Н3/Н4:Рабочий насос 3"
	},
	"tc_8_91_10": {
		"caption": "ШАТНЦ-Н3/Н4:Рабочий насос 4"
	},
	"tc_8_91_11": {
		"caption": "ШАТНЦ-Н3/Н4:ВКЛ. Насос 3"
	},
	"tc_8_91_12": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 3: Обрыв катушки"
	},
	"tc_8_91_13": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 3: Тепловая защита"
	},
	"tc_8_91_14": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 3: Защита по перепаду"
	},
	"tc_8_91_15": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 3: Залипание контактора"
	},
	"tc_8_91_16": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 3: Авария питания"
	},
	"tc_8_91_17": {
		"caption": "ШАТНЦ-Н3/Н4:ВКЛ. Насос 4"
	},
	"tc_8_91_18": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 4: Обрыв катушки"
	},
	"tc_8_91_19": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 4: Тепловая защита"
	},
	"tc_8_91_20": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 4: Защита по перепаду"
	},
	"tc_8_91_21": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 4: Залипание контактора"
	},
	"tc_8_91_22": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 4: Авария питания"
	},
	"tc_8_91_23": {
		"caption": "ШАТНЦ-Н3/Н4: Авария ПУ-1"
	},
	"tc_8_91_24": {
		"caption": "ШАТНЦ-Н3/Н4: Авария ПУ-2"
	},
	"tc_8_91_25": {
		"caption": "ШАТНЦ-Н3/Н4: Защита по сухому ходу"
	},
	"tc_8_91_26": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 3: Авария"
	},
	"tc_8_91_27": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 4: Авария"
	},
	"tc_8_91_28": {
		"caption": "ШАТНЦ-Н3/Н4: Авария"
	},
	"tc_8_91_200": {
		"caption": "Нет связи ШАТНЦ-Н3/Н4"
	},
	"tc_8_92_200": {
		"caption": "Сч.Э.PI1 ЭЩ-И Нет связи"
	},
	"tc_8_92_201": {
		"caption": "Котел EK1 включен"
	},
	"tc_8_92_202": {
		"caption": "Котел EK1 неполнофазный режим"
	},
	"tc_8_93_200": {
		"caption": "Сч.Э.PI2 ЭЩ-И Нет связи"
	},
	"tc_8_93_201": {
		"caption": "Котел EK2 включен"
	},
	"tc_8_93_202": {
		"caption": "Котел EK2 неполнофазный режим"
	},
	"tc_8_94_200": {
		"caption": "FORT-1 Нет связи"
	},
	"tc_8_96_121": {
		"caption": "ЭКОНОМ-1 АВТ.КОНТУР-1"
	},
	"tc_8_96_122": {
		"caption": "ЭКОНОМ-1 АВТ.КОНТУР-2"
	},
	"tc_8_96_123": {
		"caption": "ЭКОНОМ-1 АВТ.КОНТУР-3"
	},
	"tc_8_96_131": {
		"caption": "ЭКОНОМ-1 АВТ. \"НОЧЬ\""
	},
	"tc_8_96_133": {
		"caption": "ЭКОНОМ-1 АВТ. \"ПОЛУПИК\""
	},
	"tc_8_96_200": {
		"caption": "ЭКОНОМ-1 Нет связи"
	},
	"tc_8_97_2": {
		"caption": "IN:Авария-Н1/Н2"
	},
	"tc_8_97_3": {
		"caption": "IN:Авария-Н3/Н4"
	},
	"tc_8_97_4": {
		"caption": "IN:Авария-В1"
	},
	"tc_8_97_5": {
		"caption": "IN:Авария-В2"
	},
	"tc_8_97_6": {
		"caption": "IN:Авария-EK1"
	},
	"tc_8_97_7": {
		"caption": "IN:Авария-EK2"
	},
	"tc_8_97_8": {
		"caption": "IN:Уровень 3 (максимум)"
	},
	"tc_8_97_9": {
		"caption": "IN:Уровент 2 (норма)"
	},
	"tc_8_97_10": {
		"caption": "IN:Уровень 1(минимум)"
	},
	"tc_8_97_11": {
		"caption": "IN:Авария питания секц.-1"
	},
	"tc_8_97_12": {
		"caption": "IN:Авария питания секц.-2"
	},
	"tc_8_97_13": {
		"caption": "IN:Низкое давление (отопление)"
	},
	"tc_8_97_14": {
		"caption": "IN:Ночь (эконом)"
	},
	"tc_8_97_15": {
		"caption": "IN:Полупик+треб.отопления (эконом)"
	},
	"tc_8_97_16": {
		"caption": "IN:Пик (счетчик ЭЭ)"
	},
	"tc_8_97_17": {
		"caption": "IN:Запрет внешнего управления"
	},
	"tc_8_97_18": {
		"caption": "IN:Термостат ст.1"
	},
	"tc_8_97_19": {
		"caption": "IN:Термостат ст.2"
	},
	"tc_8_97_20": {
		"caption": "IN:Кнопка аварийной остановки"
	},
	"tc_8_97_21": {
		"caption": "IN:Зима/Лето"
	},
	"tc_8_97_22": {
		"caption": "IN:Ремонт К1"
	},
	"tc_8_97_23": {
		"caption": "IN:Ремонт К2"
	},
	"tc_8_97_24": {
		"caption": "LS:At_vent (предупреждения вентиляции)"
	},
	"tc_8_97_25": {
		"caption": "LS:Av_vent (авария вентиляции)"
	},
	"tc_8_97_26": {
		"caption": "LS:At_podp (предупреждения подпитки)"
	},
	"tc_8_97_27": {
		"caption": "LS:Av_podp (авария подпитки)"
	},
	"tc_8_97_28": {
		"caption": "LS:At_circ (предупреждения циркуляции)"
	},
	"tc_8_97_29": {
		"caption": "LS:Av_circ (авария циркуляции)"
	},
	"tc_8_97_30": {
		"caption": "LS:F_reg (флаг режима внешнего управления)"
	},
	"tc_8_97_31": {
		"caption": "LS:F_ek1 (флаг внешнего управления ek1)"
	},
	"tc_8_97_32": {
		"caption": "LS:F_ek2 (флаг внешнего управления ek2)"
	},
	"tc_8_97_33": {
		"caption": "LS:Av_nag1 (авария нагревателя EK1)"
	},
	"tc_8_97_34": {
		"caption": "LS:Av_nag2 (авария нагревателя EK2)"
	},
	"tc_8_97_35": {
		"caption": "LS:Reg_avt (Режим внешнего/автономного управления)"
	},
	"tc_8_97_36": {
		"caption": "LS:Pu_nag1 (Флаг разрешения нагрева EK1)"
	},
	"tc_8_97_37": {
		"caption": "LS:Pu_nag2 (Флаг разрешения нагрева EK2)"
	},
	"tc_8_97_38": {
		"caption": "LS:At_vena (предупреждения установки)"
	},
	"tc_8_97_39": {
		"caption": "LS:Av_vena (авария установки)"
	},
	"tc_8_97_40": {
		"caption": "Авария ШАТНЦ-Н1/Н2"
	},
	"tc_8_97_41": {
		"caption": "Авария ШАТНЦ-Н3/Н4"
	},
	"tc_8_97_42": {
		"caption": "Авария ШУВ-1"
	},
	"tc_8_97_43": {
		"caption": "Авария ШУВ-2"
	},
	"tc_8_97_44": {
		"caption": "Авария EK-1"
	},
	"tc_8_97_45": {
		"caption": "Авария EK-2"
	},
	"tc_8_97_46": {
		"caption": "Авария ПЕРЕЛИВ БАКА"
	},
	"tc_8_97_47": {
		"caption": "Авария НИЗКИЙ УРОВЕНЬ БАКА"
	},
	"tc_8_97_48": {
		"caption": "Авария ОТСУТВИЕ НАПР. СЕКЦ.1"
	},
	"tc_8_97_49": {
		"caption": "Авария ОТСУТВИЕ НАПР. СЕКЦ.2"
	},
	"tc_8_97_50": {
		"caption": "Авария НИЗКОЕ ДАВЛЕНИЕ"
	},
	"tc_8_97_51": {
		"caption": "Пониженная температура объекта",
		"point": 1
	},
	"tc_8_97_52": {
		"caption": "Общий стоп"
	},
	"tc_8_97_53": {
		"caption": "Режим ЛЕТО"
	},
	"tc_8_97_54": {
		"caption": "Ремонт ЕК-1"
	},
	"tc_8_97_55": {
		"caption": "Ремонт ЕК-2"
	},
	"tc_8_97_56": {
		"caption": "LS:Наличие обмена"
	},
	"tc_8_97_57": {
		"caption": "OUT:Электрокотел EK1 (50)"
	},
	"tc_8_97_58": {
		"caption": "OUT:Электрокотел EK2 (100)"
	},
	"tc_8_97_59": {
		"caption": "OUT:ШАТНЦ-Н1/Н2"
	},
	"tc_8_97_60": {
		"caption": "OUT:ШАТНЦ-Н3/Н4"
	},
	"tc_8_97_61": {
		"caption": "OUT:Вентилятор 1"
	},
	"tc_8_97_62": {
		"caption": "OUT:Вентилятор 2"
	},
	"tc_8_97_63": {
		"caption": "OUT:Эл.клапан подпитки системы КЕ3"
	},
	"tc_8_97_64": {
		"caption": "OUT:Эл.клапан подпитки ТА-25 КЕ4"
	},
	"tc_8_97_65": {
		"caption": "OUT:Предупреждение (сигнализация)"
	},
	"tc_8_97_66": {
		"caption": "OUT:Авария (сигнализация)"
	},
	"tc_8_97_67": {
		"caption": "OUT:Внешнее упр.запрещено (сигнализация)"
	},
	"tc_8_97_68": {
		"caption": "OUT:Аварийный ручной стоп"
	},
	"tc_8_97_200": {
		"caption": "Нет связи U-v120"
	},
	"tc_8_126_100": {
		"caption": "Отопительный сезон включен"
	},
	"ti_8_90_41": {
		"caption": "ШАТНЦ-Н1/Н2:Время циклической работы насосов"
	},
	"ti_8_90_42": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Время наработки"
	},
	"ti_8_90_43": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Время наработки"
	},
	"ti_8_90_44": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 1: Время работы в цикле"
	},
	"ti_8_90_45": {
		"caption": "ШАТНЦ-Н1/Н2:Насос 2: Время работы в цикле"
	},
	"ti_8_91_41": {
		"caption": "ШАТНЦ-Н3/Н4:Время циклической работы насосов"
	},
	"ti_8_91_42": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 1: Время наработки"
	},
	"ti_8_91_43": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 2: Время наработки"
	},
	"ti_8_91_44": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 1: Время работы в цикле"
	},
	"ti_8_91_45": {
		"caption": "ШАТНЦ-Н3/Н4:Насос 2: Время работы в цикле"
	},
	"ti_8_92_1": {
		"caption": "Сч.Э.PI1 ЭЩ-И Текущая активная энергия"
	},
	"ti_8_92_2": {
		"caption": "Сч.Э.PI1 ЭЩ-И Т1 Активная энергия"
	},
	"ti_8_92_3": {
		"caption": "Сч.Э.PI1 ЭЩ-И Т2 Активная энергия"
	},
	"ti_8_92_4": {
		"caption": "Сч.Э.PI1 ЭЩ-И Т3 Активная энергия"
	},
	"ti_8_92_5": {
		"caption": "Сч.Э.PI1 ЭЩ-И Т4 Активная энергия"
	},
	"ti_8_92_21": {
		"caption": "Сч.Э.PI1 ЭЩ-И Текущая реактивная энергия"
	},
	"ti_8_92_31": {
		"caption": "Сч.Э.PI1 ЭЩ-И Угол между фазами \"А\" и \"В\""
	},
	"ti_8_92_32": {
		"caption": "Сч.Э.PI1 ЭЩ-И Угол между фазами \"А\" и \"С\""
	},
	"ti_8_92_41": {
		"caption": "Сч.Э.PI1 ЭЩ-И Номер тарифа"
	},
	"ti_8_92_101": {
		"caption": "Сч.Э.PI1 ЭЩ-И Активная мощность фаза \"А\""
	},
	"ti_8_92_102": {
		"caption": "Сч.Э.PI1 ЭЩ-И Активная мощность фаза \"B\""
	},
	"ti_8_92_103": {
		"caption": "Сч.Э.PI1 ЭЩ-И Активная мощность фаза \"C\""
	},
	"ti_8_92_104": {
		"caption": "Сч.Э.PI1 ЭЩ-И Суммарная активная мощность",
		"point": 1
	},
	"ti_8_92_121": {
		"caption": "Сч.Э.PI1 ЭЩ-И Текущая реактивная мощность ф.\"А\""
	},
	"ti_8_92_122": {
		"caption": "Сч.Э.PI1 ЭЩ-И Текущая реактивная мощность ф.\"B\""
	},
	"ti_8_92_123": {
		"caption": "Сч.Э.PI1 ЭЩ-И Текущая реактивная мощность ф.\"С\""
	},
	"ti_8_92_141": {
		"caption": "Сч.Э.PI1 ЭЩ-И Напряжение фаза \"А\""
	},
	"ti_8_92_142": {
		"caption": "Сч.Э.PI1 ЭЩ-И Напряжение фаза \"В\""
	},
	"ti_8_92_143": {
		"caption": "Сч.Э.PI1 ЭЩ-И Напряжение фаза \"С\""
	},
	"ti_8_92_151": {
		"caption": "Сч.Э.PI1 ЭЩ-И Ток фаза \"А\""
	},
	"ti_8_92_152": {
		"caption": "Сч.Э.PI1 ЭЩ-И Ток фаза \"B\""
	},
	"ti_8_92_153": {
		"caption": "Сч.Э.PI1 ЭЩ-И Ток фаза \"C\""
	},
	"ti_8_92_161": {
		"caption": "Сч.Э.PI1 ЭЩ-И Коэфф.мощности фаза \"А\""
	},
	"ti_8_92_162": {
		"caption": "Сч.Э.PI1 ЭЩ-И Коэфф.мощности фаза \"В\""
	},
	"ti_8_92_163": {
		"caption": "Сч.Э.PI1 ЭЩ-И Коэфф.мощности фаза \"С\""
	},
	"ti_8_93_1": {
		"caption": "Сч.Э.PI2 ЭЩ-И Текущая активная энергия"
	},
	"ti_8_93_2": {
		"caption": "Сч.Э.PI2 ЭЩ-И Т1 Активная энергия"
	},
	"ti_8_93_3": {
		"caption": "Сч.Э.PI2 ЭЩ-И Т2 Активная энергия"
	},
	"ti_8_93_4": {
		"caption": "Сч.Э.PI2 ЭЩ-И Т3 Активная энергия"
	},
	"ti_8_93_5": {
		"caption": "Сч.Э.PI2 ЭЩ-И Т4 Активная энергия"
	},
	"ti_8_93_21": {
		"caption": "Сч.Э.PI2 ЭЩ-И Текущая реактивная энергия"
	},
	"ti_8_93_31": {
		"caption": "Сч.Э.PI2 ЭЩ-И Угол между фазами \"А\" и \"В\""
	},
	"ti_8_93_32": {
		"caption": "Сч.Э.PI2 ЭЩ-И Угол между фазами \"А\" и \"С\""
	},
	"ti_8_93_41": {
		"caption": "Сч.Э.PI2 ЭЩ-И Номер тарифа"
	},
	"ti_8_93_101": {
		"caption": "Сч.Э.PI2 ЭЩ-И Активная мощность фаза \"А\""
	},
	"ti_8_93_102": {
		"caption": "Сч.Э.PI2 ЭЩ-И Активная мощность фаза \"B\""
	},
	"ti_8_93_103": {
		"caption": "Сч.Э.PI2 ЭЩ-И Активная мощность фаза \"C\""
	},
	"ti_8_93_104": {
		"caption": "Сч.Э.PI2 ЭЩ-И Суммарная активная мощность",
		"point": 1
	},
	"ti_8_93_121": {
		"caption": "Сч.Э.PI2 ЭЩ-И Текущая реактивная мощность ф.\"А\""
	},
	"ti_8_93_122": {
		"caption": "Сч.Э.PI2 ЭЩ-И Текущая реактивная мощность ф.\"B\""
	},
	"ti_8_93_123": {
		"caption": "Сч.Э.PI2 ЭЩ-И Текущая реактивная мощность ф.\"С\""
	},
	"ti_8_93_141": {
		"caption": "Сч.Э.PI2 ЭЩ-И Напряжение фаза \"А\""
	},
	"ti_8_93_142": {
		"caption": "Сч.Э.PI2 ЭЩ-И Напряжение фаза \"В\""
	},
	"ti_8_93_143": {
		"caption": "Сч.Э.PI2 ЭЩ-И Напряжение фаза \"С\""
	},
	"ti_8_93_151": {
		"caption": "Сч.Э.PI2 ЭЩ-И Ток фаза \"А\""
	},
	"ti_8_93_152": {
		"caption": "Сч.Э.PI2 ЭЩ-И Ток фаза \"B\""
	},
	"ti_8_93_153": {
		"caption": "Сч.Э.PI2 ЭЩ-И Ток фаза \"C\""
	},
	"ti_8_93_161": {
		"caption": "Сч.Э.PI2 ЭЩ-И Коэфф.мощности фаза \"А\""
	},
	"ti_8_93_162": {
		"caption": "Сч.Э.PI2 ЭЩ-И Коэфф.мощности фаза \"В\""
	},
	"ti_8_93_163": {
		"caption": "Сч.Э.PI2 ЭЩ-И Коэфф.мощности фаза \"С\""
	},
	"ti_8_94_5": {
		"caption": "КОНТУР-1 тепловая мощность",
		"point": 1
	},
	"ti_8_94_7": {
		"caption": "КОНТУР-1 температура в подающем трубопроводе",
		"point": 1
	},
	"ti_8_94_8": {
		"caption": "КОНТУР-1 температура в обратном трубопроводе",
		"point": 1
	},
	"ti_8_94_14": {
		"caption": "КОНТУР-1 суммарный объемный расход"
	},
	"ti_8_94_16": {
		"caption": "КОНТУР-1 суммарный массовый расход"
	},
	"ti_8_94_18": {
		"caption": "КОНТУР-1 суммарная энергия"
	},
	"ti_8_94_20": {
		"caption": "КОНТУР-1 Суммарная энергия"
	},
	"ti_8_94_21": {
		"caption": "FORT-1 время работы теплосчетчика без ошибки"
	},
	"ti_8_94_22": {
		"caption": "FORT-1 время работы с ошибкой теплосчетчика"
	},
	"ti_8_94_23": {
		"caption": "КОНТУР-1 массовый расход"
	},
	"ti_8_94_25": {
		"caption": "КОНТУР-1 объемный расход"
	},
	"ti_8_94_27": {
		"caption": "КОНТУР-1 Расход Т/Э за час"
	},
	"ti_8_94_29": {
		"caption": "КОНТУР-1 Расход Т/Э за сутки"
	},
	"ti_8_95_1": {
		"caption": "ЭЩ-И Текущая активная энергия"
	},
	"ti_8_95_2": {
		"caption": "ЭЩ-И Т1 Активная энергия"
	},
	"ti_8_95_3": {
		"caption": "ЭЩ-И Т2 Активная энергия"
	},
	"ti_8_95_4": {
		"caption": "ЭЩ-И Т3 Активная энергия"
	},
	"ti_8_96_1": {
		"caption": "ЭКОНОМ-1 Т1-температура в баке",
		"point": 1
	},
	"ti_8_96_2": {
		"caption": "ЭКОНОМ-1 Т2-температура подачи в нагрузку",
		"point": 1
	},
	"ti_8_96_3": {
		"caption": "ЭКОНОМ-1 Т3 - температура наружного воздуха",
		"point": 1
	},
	"ti_8_96_4": {
		"caption": "ЭКОНОМ-1 Т4 - температура в контрольном помещении",
		"point": 1
	},
	"ti_8_96_5": {
		"caption": "ЭКОНОМ-1 Т5 температура в помещении узла ВЕНА",
		"point": 1
	},
	"ti_8_96_6": {
		"caption": "ЭКОНОМ-1 Т6 - температура на входе котлов EK1",
		"point": 1
	},
	"ti_8_96_7": {
		"caption": "ЭКОНОМ-1 Т7 - температура на выходе котла EK1",
		"point": 1
	},
	"ti_8_96_8": {
		"caption": "ЭКОНОМ-1 Т8 - температура на выходе котла EK2",
		"point": 1
	},
	"ti_8_96_9": {
		"caption": "ЭКОНОМ-1 Т9 - температура обратки с нагрузки",
		"point": 1
	},
	"ti_8_96_10": {
		"caption": "ЭКОНОМ-1 Т10 - температура на выходе Т/О нагрузки",
		"point": 1
	},
	"ti_8_96_11": {
		"caption": "ЭКОНОМ-1 Т11 - темппература на входе Т/О генерации",
		"point": 1
	},
	"ti_8_96_13": {
		"caption": "Дельта Ттог теплообменника",
		"point": 1
	},
	"ti_8_96_14": {
		"caption": "Дельта Тн нагрузки",
		"point": 1
	},
	"ti_8_96_15": {
		"caption": "Дельта Ттон теплообменника на нагрузку",
		"point": 1
	},
	"ti_8_96_16": {
		"caption": "Дельта Тek1 котла EK1",
		"point": 1
	},
	"ti_8_96_17": {
		"caption": "Дельта Тek2 котла EK2",
		"point": 1
	},
	"ti_8_96_21": {
		"caption": "ЭКОНОМ-1 Тзд1",
		"point": 1
	},
	"ti_8_96_22": {
		"caption": "ЭКОНОМ-1 Тзд2",
		"point": 1
	},
	"ti_8_96_23": {
		"caption": "ЭКОНОМ-1 Тзд3",
		"point": 1
	},
	"ti_8_96_31": {
		"caption": "ЭКОНОМ-1 Тсн1"
	},
	"ti_8_96_32": {
		"caption": "ЭКОНОМ-1 Тсн2"
	},
	"ti_8_96_33": {
		"caption": "ЭКОНОМ-1 Тсн3"
	},
	"ti_8_96_64": {
		"caption": "ЭКОНОМ-1 Положение клапана"
	},
	"ti_8_96_66": {
		"caption": "Средняя температура Н.В. за сутки",
		"point": 1
	},
	"ti_8_97_69": {
		"caption": "AN: Разрешенное время подпитки бака (T1_podp)"
	},
	"ti_8_97_70": {
		"caption": "AN: Время запрета повторной подпитки бака (T2_podp)"
	},
	"ti_8_97_71": {
		"caption": "AN: Разрешенное время подпитки системы (T3_podp)"
	},
	"ti_8_97_72": {
		"caption": "AN: Время запрета повторной подпитки системы (T4_podp)"
	},
	"ti_8_97_73": {
		"caption": "AN: Время работы циркуляции контура системы (T1_circ)"
	},
	"ti_8_97_74": {
		"caption": "AN: Таймер перехода с режима «Лето» на «Зима» (T1_nag)"
	},
	"ti_8_97_75": {
		"caption": "AN:обмен с мастером"
	},
	"ti_8_98_1": {
		"caption": "Qэ Расход через котел EK1"
	},
	"ti_8_98_2": {
		"caption": "Qэ Расход через котел EK2"
	},
	"ti_8_98_3": {
		"caption": "Qр Расход через ТО"
	},
	"ti_8_99_1": {
		"caption": "ЭКОНОМ-1 1Т -25"
	},
	"ti_8_99_2": {
		"caption": "ЭКОНОМ-1 1Т -20"
	},
	"ti_8_99_3": {
		"caption": "ЭКОНОМ-1 1Т -15"
	},
	"ti_8_99_4": {
		"caption": "ЭКОНОМ-1 1Т -10"
	},
	"ti_8_99_5": {
		"caption": "ЭКОНОМ-1 1Т -5"
	},
	"ti_8_99_6": {
		"caption": "ЭКОНОМ-1 1Т +0"
	},
	"ti_8_99_7": {
		"caption": "ЭКОНОМ-1 1Т +5"
	},
	"ti_8_99_8": {
		"caption": "ЭКОНОМ-1 1Т +10"
	},
	"ti_8_99_21": {
		"caption": "ЭКОНОМ-1 3Т -25"
	},
	"ti_8_99_22": {
		"caption": "ЭКОНОМ-1 3Т -20"
	},
	"ti_8_99_23": {
		"caption": "ЭКОНОМ-1 3Т -15"
	},
	"ti_8_99_24": {
		"caption": "ЭКОНОМ-1 3Т -10"
	},
	"ti_8_99_25": {
		"caption": "ЭКОНОМ-1 3Т -5"
	},
	"ti_8_99_26": {
		"caption": "ЭКОНОМ-1 3Т +0"
	},
	"ti_8_99_27": {
		"caption": "ЭКОНОМ-1 3Т +5"
	},
	"ti_8_99_28": {
		"caption": "ЭКОНОМ-1 3Т +10"
	},
	"ti_8_100_1": {
		"caption": "ЭКОНОМ-1 Н3 Пн.Ут-В"
	},
	"ti_8_100_2": {
		"caption": "ЭКОНОМ-1 Н3 Пн.Ут-О"
	},
	"ti_8_100_3": {
		"caption": "ЭКОНОМ-1 Н3 Вт.Ут-В"
	},
	"ti_8_100_4": {
		"caption": "ЭКОНОМ-1 Н3 Вт.Ут-О"
	},
	"ti_8_100_5": {
		"caption": "ЭКОНОМ-1 Н3 Ср.Ут-В"
	},
	"ti_8_100_6": {
		"caption": "ЭКОНОМ-1 Н3 Ср.Ут-О"
	},
	"ti_8_100_7": {
		"caption": "ЭКОНОМ-1 Н3 Чт.Ут-В"
	},
	"ti_8_100_8": {
		"caption": "ЭКОНОМ-1 Н3 Чт.Ут-О"
	},
	"ti_8_100_9": {
		"caption": "ЭКОНОМ-1 Н3 Пт.Ут-В"
	},
	"ti_8_100_10": {
		"caption": "ЭКОНОМ-1 Н3 Пт.Ут-О"
	},
	"ti_8_100_11": {
		"caption": "ЭКОНОМ-1 Н3 Сб.Ут-В"
	},
	"ti_8_100_12": {
		"caption": "ЭКОНОМ-1 Н3 Сб.Ут-О"
	},
	"ti_8_100_13": {
		"caption": "ЭКОНОМ-1 Н3 Вс.Ут-В"
	},
	"ti_8_100_14": {
		"caption": "ЭКОНОМ-1 Н3 Вс.Ут-О"
	},
	"ti_8_100_15": {
		"caption": "ЭКОНОМ-1 Н3 Пн.Вч-В"
	},
	"ti_8_100_16": {
		"caption": "ЭКОНОМ-1 Н3 Пн.Вч-О"
	},
	"ti_8_100_17": {
		"caption": "ЭКОНОМ-1 Н3 Вт.Вч-В"
	},
	"ti_8_100_18": {
		"caption": "ЭКОНОМ-1 Н3 Вт.Вч-О"
	},
	"ti_8_100_19": {
		"caption": "ЭКОНОМ-1 Н3 Ср.Вч-В"
	},
	"ti_8_100_20": {
		"caption": "ЭКОНОМ-1 Н3 Ср.Вч-О"
	},
	"ti_8_100_21": {
		"caption": "ЭКОНОМ-1 Н3 Чт.Вч-В"
	},
	"ti_8_100_22": {
		"caption": "ЭКОНОМ-1 Н3 Чт.Вч-О"
	},
	"ti_8_100_23": {
		"caption": "ЭКОНОМ-1 Н3 Пт.Вч-В"
	},
	"ti_8_100_24": {
		"caption": "ЭКОНОМ-1 Н3 Пт.Вч-О"
	},
	"ti_8_100_25": {
		"caption": "ЭКОНОМ-1 Н3 Сб.Вч-В"
	},
	"ti_8_100_26": {
		"caption": "ЭКОНОМ-1 Н3 Сб.Вч-О"
	},
	"ti_8_100_27": {
		"caption": "ЭКОНОМ-1 Н3 Вс.Вч-В"
	},
	"ti_8_100_28": {
		"caption": "ЭКОНОМ-1 Н3 Вс.Вч-О"
	},
	"ti_8_100_29": {
		"caption": "ЭКОНОМ-1 Н1 Пн.Ут-В"
	},
	"ti_8_100_30": {
		"caption": "ЭКОНОМ-1 Н1 Пн.Ут-О"
	},
	"ti_8_100_31": {
		"caption": "ЭКОНОМ-1 Н1 Вт.Ут-В"
	},
	"ti_8_100_32": {
		"caption": "ЭКОНОМ-1 Н1 Вт.Ут-О"
	},
	"ti_8_100_33": {
		"caption": "ЭКОНОМ-1 Н1 Ср.Ут-В"
	},
	"ti_8_100_34": {
		"caption": "ЭКОНОМ-1 Н1 Ср.Ут-О"
	},
	"ti_8_100_35": {
		"caption": "ЭКОНОМ-1 Н1 Чт.Ут-В"
	},
	"ti_8_100_36": {
		"caption": "ЭКОНОМ-1 Н1 Чт.Ут-О"
	},
	"ti_8_100_37": {
		"caption": "ЭКОНОМ-1 Н1 Пт.Ут-В"
	},
	"ti_8_100_38": {
		"caption": "ЭКОНОМ-1 Н1 Пт.Ут-О"
	},
	"ti_8_100_39": {
		"caption": "ЭКОНОМ-1 Н1 Сб.Ут-В"
	},
	"ti_8_100_40": {
		"caption": "ЭКОНОМ-1 Н1 Сб.Ут-О"
	},
	"ti_8_100_41": {
		"caption": "ЭКОНОМ-1 Н1 Вс.Ут-В"
	},
	"ti_8_100_42": {
		"caption": "ЭКОНОМ-1 Н1 Вс.Ут-О"
	},
	"ti_8_100_43": {
		"caption": "ЭКОНОМ-1 Н1 Пн.Вч-В"
	},
	"ti_8_100_44": {
		"caption": "ЭКОНОМ-1 Н1 Пн.Вч-О"
	},
	"ti_8_100_45": {
		"caption": "ЭКОНОМ-1 Н1 Вт.Вч-В"
	},
	"ti_8_100_46": {
		"caption": "ЭКОНОМ-1 Н1 Вт.Вч-О"
	},
	"ti_8_100_47": {
		"caption": "ЭКОНОМ-1 Н1 Ср.Вч-В"
	},
	"ti_8_100_48": {
		"caption": "ЭКОНОМ-1 Н1 Ср.Вч-О"
	},
	"ti_8_100_49": {
		"caption": "ЭКОНОМ-1 Н1 Чт.Вч-В"
	},
	"ti_8_100_50": {
		"caption": "ЭКОНОМ-1 Н1 Чт.Вч-О"
	},
	"ti_8_100_51": {
		"caption": "ЭКОНОМ-1 Н1 Пт.Вч-В"
	},
	"ti_8_100_52": {
		"caption": "ЭКОНОМ-1 Н1 Пт.Вч-О"
	},
	"ti_8_100_53": {
		"caption": "ЭКОНОМ-1 Н1 Сб.Вч-В"
	},
	"ti_8_100_54": {
		"caption": "ЭКОНОМ-1 Н1 Сб.Вч-О"
	},
	"ti_8_100_55": {
		"caption": "ЭКОНОМ-1 Н1 Вс.Вч-В"
	},
	"ti_8_100_56": {
		"caption": "ЭКОНОМ-1 Н1 Вс.Вч-О"
	},
	"ti_8_101_1": {
		"caption": "ЭКОНОМ-1 К1 Пн.В"
	},
	"ti_8_101_2": {
		"caption": "ЭКОНОМ-1 К1 Пн.О"
	},
	"ti_8_101_3": {
		"caption": "ЭКОНОМ-1 К1 Вт.В"
	},
	"ti_8_101_4": {
		"caption": "ЭКОНОМ-1 К1 Вт.О"
	},
	"ti_8_101_5": {
		"caption": "ЭКОНОМ-1 К1 Ср.В"
	},
	"ti_8_101_6": {
		"caption": "ЭКОНОМ-1 К1 Ср.О"
	},
	"ti_8_101_7": {
		"caption": "ЭКОНОМ-1 К1 Чт.В"
	},
	"ti_8_101_8": {
		"caption": "ЭКОНОМ-1 К1 Чт.О"
	},
	"ti_8_101_9": {
		"caption": "ЭКОНОМ-1 К1 Пт.В"
	},
	"ti_8_101_10": {
		"caption": "ЭКОНОМ-1 К1 Пт.О"
	},
	"ti_8_101_11": {
		"caption": "ЭКОНОМ-1 К1 Сб.В"
	},
	"ti_8_101_12": {
		"caption": "ЭКОНОМ-1 К1 Сб.О"
	},
	"ti_8_101_13": {
		"caption": "ЭКОНОМ-1 К1 Вс.В"
	},
	"ti_8_101_14": {
		"caption": "ЭКОНОМ-1 К1 Вс.О"
	},
	"ti_8_101_21": {
		"caption": "ЭКОНОМ-1 К2 Пн.В"
	},
	"ti_8_101_22": {
		"caption": "ЭКОНОМ-1 К2 Пн.О"
	},
	"ti_8_101_23": {
		"caption": "ЭКОНОМ-1 К2 Вт.В"
	},
	"ti_8_101_24": {
		"caption": "ЭКОНОМ-1 К2 Вт.О"
	},
	"ti_8_101_25": {
		"caption": "ЭКОНОМ-1 К2 Ср.В"
	},
	"ti_8_101_26": {
		"caption": "ЭКОНОМ-1 К2 Ср.О"
	},
	"ti_8_101_27": {
		"caption": "ЭКОНОМ-1 К2 Чт.В"
	},
	"ti_8_101_28": {
		"caption": "ЭКОНОМ-1 К2 Чт.О"
	},
	"ti_8_101_29": {
		"caption": "ЭКОНОМ-1 К2 Пт.В"
	},
	"ti_8_101_30": {
		"caption": "ЭКОНОМ-1 К2 Пт.О"
	},
	"ti_8_101_31": {
		"caption": "ЭКОНОМ-1 К2 Сб.В"
	},
	"ti_8_101_32": {
		"caption": "ЭКОНОМ-1 К2 Сб.О"
	},
	"ti_8_101_33": {
		"caption": "ЭКОНОМ-1 К2 Вс.В"
	},
	"ti_8_101_34": {
		"caption": "ЭКОНОМ-1 К2 Вс.О"
	},
	"ti_8_101_41": {
		"caption": "ЭКОНОМ-1 К3 Пн.В"
	},
	"ti_8_101_42": {
		"caption": "ЭКОНОМ-1 К3 Пн.О"
	},
	"ti_8_101_43": {
		"caption": "ЭКОНОМ-1 К3 Вт.В"
	},
	"ti_8_101_44": {
		"caption": "ЭКОНОМ-1 К3 Вт.О"
	},
	"ti_8_101_45": {
		"caption": "ЭКОНОМ-1 К3 Ср.В"
	},
	"ti_8_101_46": {
		"caption": "ЭКОНОМ-1 К3 Ср.О"
	},
	"ti_8_101_47": {
		"caption": "ЭКОНОМ-1 К3 Чт.В"
	},
	"ti_8_101_48": {
		"caption": "ЭКОНОМ-1 К3 Чт.О"
	},
	"ti_8_101_49": {
		"caption": "ЭКОНОМ-1 К3 Пт.В"
	},
	"ti_8_101_50": {
		"caption": "ЭКОНОМ-1 К3 Пт.О"
	},
	"ti_8_101_51": {
		"caption": "ЭКОНОМ-1 К3 Сб.В"
	},
	"ti_8_101_52": {
		"caption": "ЭКОНОМ-1 К3 Сб.О"
	},
	"ti_8_101_53": {
		"caption": "ЭКОНОМ-1 К3 Вс.В"
	},
	"ti_8_101_54": {
		"caption": "ЭКОНОМ-1 К3 Вс.О"
	},
	"ti_8_126_6": {
		"caption": "Стоимость кВт*ч Э/Э"
	},
	"ti_8_126_7": {
		"caption": "Коэффициент Т3"
	},
	"ti_8_126_8": {
		"caption": "Коэффициент Т2"
	},
	"ti_8_126_9": {
		"caption": "Коэффициент Т1"
	},
	"ti_8_126_10": {
		"caption": "Стоимость Гкал Т/Э"
	},
	"ti_8_126_11": {
		"caption": "Потребленная Э/Э за сутки"
	},
	"ti_8_126_12": {
		"caption": "Выработанная Т/Э за сутки"
	},
	"ti_8_126_13": {
		"caption": "КПД системы за сутки"
	},
	"ti_8_126_14": {
		"caption": "Потребленная Э/Э Т1 за сутки"
	},
	"ti_8_126_15": {
		"caption": "Потребленная Э/Э Т2 за сутки"
	},
	"ti_8_126_16": {
		"caption": "Потребленная Э/Э Т3 за сутки"
	},
	"ti_8_126_17": {
		"caption": "Стоимость Э/Э Т1 за сутки"
	},
	"ti_8_126_18": {
		"caption": "Стоимость Э/Э Т2 за сутки"
	},
	"ti_8_126_19": {
		"caption": "Стоимость Э/Э Т3 за сутки"
	},
	"ti_8_126_20": {
		"caption": "Стоимость Э/Э за сутки"
	},
	"ti_8_126_21": {
		"caption": "Стоимость Т/Э за сутки"
	},
	"ti_8_126_22": {
		"caption": "Экономия за сутки"
	},
	"ti_8_126_23": {
		"caption": "Себестоимость Гкал за сутки"
	},
	"ti_8_126_24": {
		"caption": "Потребленная Э/Э за декаду"
	},
	"ti_8_126_25": {
		"caption": "Выработанная Т/Э за декаду"
	},
	"ti_8_126_26": {
		"caption": "Стоимость Э/Э за декаду"
	},
	"ti_8_126_27": {
		"caption": "Стоимость Т/Э за декаду"
	},
	"ti_8_126_28": {
		"caption": "Экономия за декаду"
	},
	"ti_8_126_29": {
		"caption": "Себестоимость Гкал за декаду"
	},
	"ti_8_126_30": {
		"caption": "КПД системы за декаду"
	},
	"ti_8_126_31": {
		"caption": "Потребленная Э/Э Т1 за декаду"
	},
	"ti_8_126_32": {
		"caption": "Потребленная Э/Э Т2 за декаду"
	},
	"ti_8_126_33": {
		"caption": "Потребленная Э/Э Т3 за декаду"
	},
	"ti_8_126_34": {
		"caption": "Потребленная Э/Э за весь период"
	},
	"ti_8_126_35": {
		"caption": "Выработанная Т/Э за весь период"
	},
	"ti_8_126_36": {
		"caption": "Стоимость Э/Э за весь период"
	},
	"ti_8_126_37": {
		"caption": "Стоимость Т/Э за весь период"
	},
	"ti_8_126_38": {
		"caption": "Экономия за весь период"
	},
	"ti_8_126_39": {
		"caption": "Себестоимость Гкал за весь период"
	},
	"ti_8_126_40": {
		"caption": "КПД системы за весь период"
	},
	"ti_8_126_41": {
		"caption": "Потребленная Э/Э за текущий сезон"
	},
	"ti_8_126_42": {
		"caption": "Выработанная Т/Э за текущий сезон"
	},
	"ti_8_126_43": {
		"caption": "Стоимость Э/Э за текущий сезон"
	},
	"ti_8_126_44": {
		"caption": "Стоимость Т/Э за текущий сезон"
	},
	"ti_8_126_45": {
		"caption": "Экономия за текущий сезон"
	},
	"ti_8_126_46": {
		"caption": "Себестоимость Гкал за текущий сезон"
	},
	"ti_8_126_47": {
		"caption": "КПД системы за текущий сезон"
	},
	"ti_8_126_48": {
		"caption": "Потребленная Э/Э за прошедший сезон"
	},
	"ti_8_126_49": {
		"caption": "Выработанная Т/Э за прошедший сезон"
	},
	"ti_8_126_50": {
		"caption": "Стоимость Э/Э за прошедший сезон"
	},
	"ti_8_126_51": {
		"caption": "Стоимость Т/Э за прошедший сезон"
	},
	"ti_8_126_52": {
		"caption": "Экономия за прошедший сезон"
	},
	"ti_8_126_53": {
		"caption": "Себестоимость Гкал за прошедший сезон"
	},
	"ti_8_126_54": {
		"caption": "КПД системы за прошедший сезон"
	},
	"ti_8_126_101": {
		"caption": "Текущая дата День",
		"point": 0
	},
	"ti_8_126_102": {
		"caption": "Текущая дата Месяц",
		"point": 0
	},
	"ti_8_126_103": {
		"caption": "Текущая дата Год",
		"point": 0
	},
	"ti_8_126_104": {
		"caption": "Дата внедрения День",
		"point": 0
	},
	"ti_8_126_105": {
		"caption": "Дата внедрения Месяц",
		"point": 0
	},
	"ti_8_126_106": {
		"caption": "Дата внедрения Год",
		"point": 0
	},
	"ti_8_126_107": {
		"caption": "Дата возврата День",
		"point": 0
	},
	"ti_8_126_108": {
		"caption": "Дата возврата Месяц",
		"point": 0
	},
	"ti_8_126_109": {
		"caption": "Дата возврата Год",
		"point": 0
	},
	"ti_8_126_110": {
		"caption": "Срок работы Дни"
	},
	"ti_8_126_111": {
		"caption": "Срок окупаемости Дни"
	},
	"ti_8_126_121": {
		"caption": "Затраты на внедрение"
	},
	"ti_8_126_122": {
		"caption": "Затраты на эксплуатацию"
	},
	"ti_8_126_123": {
		"caption": "Суммарные затраты"
	},
	"ti_8_127_1": {
		"caption": "Мощность котлов на текущий час"
	},
	"ti_8_127_2": {
		"caption": "Мощность котлов за прошедший час"
	},
	"ti_8_127_3": {
		"caption": "Мощность в нагрузку на текущий час"
	},
	"ti_8_127_4": {
		"caption": "Мощность в нагрузку за прошедший час"
	},
	"ti_8_127_5": {
		"caption": "Запас энергии в баке"
	},
	"ti_8_127_6": {
		"caption": "Дифицит энергии в баке"
	},
	"ti_8_127_7": {
		"caption": "Потери на текущий час"
	},
	"ti_8_127_8": {
		"caption": "Потери за прошедший час"
	},
	"ti_8_127_9": {
		"caption": "Запас хода в баке"
	},
	"ti_8_127_10": {
		"caption": "Время работы EK1 (50)"
	},
	"ti_8_127_11": {
		"caption": "Время работы EK-2 (100)"
	},
	"ti_8_127_12": {
		"caption": "Время работы Н-1"
	},
	"ti_8_127_13": {
		"caption": "Время работы Н-2"
	},
	"ti_8_127_14": {
		"caption": "Время работы Н-3"
	},
	"ti_8_127_15": {
		"caption": "Время работы Н-4"
	},
	"ti_8_127_16": {
		"caption": "Количество включений EK1 (50)"
	},
	"ti_8_127_17": {
		"caption": "Количество включений EK2 (100)"
	},
	"ti_8_127_18": {
		"caption": "Количество включений Н-1"
	},
	"ti_8_127_19": {
		"caption": "Количество включений Н-2"
	},
	"ti_8_127_20": {
		"caption": "Количество включений Н-3"
	},
	"ti_8_127_21": {
		"caption": "Количество включений Н-4"
	},
	"ti_8_127_100": {
		"caption": "Тепловая потребленная мощность за час"
	},
	"ti_8_127_101": {
		"caption": "Средняя температура Н.В. за час",
		"point": 1
	},
	"ti_8_127_102": {
		"caption": "Температура в баке (15мин.)",
		"point": 1
	},
	"ti_8_127_103": {
		"caption": "Температура мин.допустимая в баке (15мин.)",
		"point": 1
	},
	"ti_8_127_104": {
		"caption": "Температура в контр.помещении (15мин.)",
		"point": 1
	},
	"ti_8_99_11": {
		"caption": "ЭКОНОМ-1 Уставка 2й контур"
	},
	"ti_8_94_9": {
		"caption": "Дельта температур подающего и обратного трубопровода",
		"point": 1
	},
	"ti_8_95_21": {
		"caption": "ЭЩ-И Текущая реактивная энергия"
	},
	"ti_8_97_78": {
		"caption": "Уровень в баке"
	},
	"tc_8_128_1": {
		"caption": "Авария на гидравлической схеме"
	},
	"tc_8_128_2": {
		"caption": "Авария на тепловой схеме"
	},
	"tc_8_128_3": {
		"caption": "Авария на электрической схеме"
	}
};


//////////////////
// WEBPACK FOOTER
// ./params.json
// module id = 105
// module chunks = 0